import { graphql } from '../../graphql';

export const sendAccessToken = graphql(`
  mutation Auth($accessToken: String!) {
    signIn(input: { accessToken: $accessToken }) {
      profile {
        ... on CompanyProfile {
          id
          name
          phone
        }
      }
      errors {
        message
        path
      }
    }
  }
`);

export const deleteCompany = graphql(`
  mutation SignOut {
    signOut {
      profile {
        ... on CompanyProfile {
          id
        }
      }
      errors {
        message
      }
    }
  }
`);

export const editProfileMutation = graphql(`
  mutation EditProfile(
    $name: String
    $email: String!
    $alternativePhone: String
  ) {
    updateProfile(
      input: { name: $name, email: $email, alternativePhone: $alternativePhone }
    ) {
      errors {
        code
        message
        path
      }
      status
      profile {
        ... on CompanyProfile {
          name
          email
          alternativePhone
        }
      }
    }
  }
`);

export const changeProfilePassword = graphql(`
  mutation ChangeProfilePassword(
    $currentPassword: String!
    $newPassword: String!
  ) {
    changeProfilePassword(
      input: { currentPassword: $currentPassword, newPassword: $newPassword }
    ) {
      errors {
        code
        message
        path
      }
      status
    }
  }
`);
